<template>
  <OverlayCard width="m" @cancel="$emit('cancel')">
    <template #title>
      {{ $t('licensing.trialStartupCard.text.title') }}
    </template>

    <template #content>
      <p v-html="$t('licensing.trialStartupCard.text.main', { count: daysLeft })" />
      <p>{{ $t('licensing.text.training') }}</p>
    </template>

    <template #footer>
      <LicenseUpgradeAction />
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LicenseUpgradeAction from '@components/license/LicenseUpgradeAction.vue';

export default defineComponent({
  emits: { cancel: null },
  name: 'LicenseTrialStartupCard',

  components: {
    LicenseUpgradeAction,
  },

  props: {
    daysLeft: {
      type: Number,
      required: true,
    },
  },
});
</script>
